var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D1FADF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#ECFDF3",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7461_28115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4974 22.9974L22.1641 24.6641L25.9141 20.9141M19.1089 16.1796C19.7787 16.1262 20.4147 15.8628 20.9261 15.4269C22.1197 14.4098 23.8751 14.4098 25.0687 15.4269C25.5801 15.8628 26.2161 16.1262 26.8859 16.1796C28.4491 16.3044 29.6904 17.5457 29.8152 19.1089C29.8686 19.7787 30.132 20.4147 30.5679 20.9261C31.585 22.1197 31.585 23.8751 30.5679 25.0687C30.132 25.5801 29.8686 26.2161 29.8152 26.8859C29.6904 28.4491 28.4491 29.6904 26.8859 29.8152C26.2161 29.8686 25.5801 30.132 25.0687 30.5679C23.8751 31.585 22.1197 31.585 20.9261 30.5679C20.4147 30.132 19.7787 29.8686 19.1089 29.8152C17.5457 29.6904 16.3044 28.4491 16.1796 26.8859C16.1262 26.2161 15.8628 25.5801 15.4269 25.0687C14.4098 23.8751 14.4098 22.1197 15.4269 20.9261C15.8628 20.4147 16.1262 19.7787 16.1796 19.1089C16.3044 17.5457 17.5457 16.3044 19.1089 16.1796Z",
    stroke: "#039855",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7461_28115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessToastIcon);
export default __webpack_public_path__ + "static/media/success-toast-icon.8bf092a5fdbd30da2f6dfd2af86afc7c.svg";
export { ForwardRef as ReactComponent };